export default string => {
  const split = string.split('-');

  return split.length > 1 ? split.join(' ') : string;
};
